<template>
  <div class="contact-us-screen">
    <div class="container contact-us-screen__content">
      <ScreenHeader class="contact-us-screen__header" data-aos="fade-down">
        <template #subtitle>
          {{ subtitle || CONTACT_US_SCREEN_DEFAULTS.subtitle }}
        </template>
        <template #title>
          {{ title || CONTACT_US_SCREEN_DEFAULTS.title }}
        </template>
        <template #text>
          {{ description || CONTACT_US_SCREEN_DEFAULTS.description }}
        </template>
      </ScreenHeader>
      <ContactForm class="contact-us-screen__form" data-aos="fade-up" />
    </div>
  </div>
</template>

<script setup lang="ts">
const CONTACT_US_SCREEN_DEFAULTS = {
  title: "Contact Us!",
  subtitle: "Get in touch with us",
  description: "If you have questions, suggestions, or simply want to say hello, feel free to reach out to us.",
}

const props = defineProps<{
  title?: string;
  subtitle?: string;
  description?: string;
}>();
</script>

<style lang="scss">
.contact-us-screen {
  padding: 64px 0;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }

  &__header {
    max-width: 512px;
  }

  &__form {
    max-width: 768px;
  }
}
</style>